import React from "react";
import {Button, Col, Container, FormCheck, FormControl, Row, Table} from "react-bootstrap";
import {GlobalContext} from "../../GlobalContext";
import {OptionalSelect} from "../common/OptionalSelect";
import {Glyph} from "../common/Glyph";

export default class SuperbillMetadataEditor extends React.Component {
    static contextType = GlobalContext;

    constructor(props) {
        super(props);

        this.state = {
            internalOrders: [],
            externalOrders: [],
            testTypes: [],
            testSubtypes: [],
            dirty: false
        }
    }

    OPTION_TYPES = [
        {value: "DX", label: "DX"},
        {value: "BOOL", label: "Checkbox"},
        {value: "OTHER", label: "Text Box"}
    ];

    componentDidMount() {
        this.loadData();
    }

    loadData = () => {
        this.context.apiRequest("GET", "/superbillMeta")
            .then(d => {
                let orders = d.data;
                if (d && d.data) {
                    this.setState({internalOrders: orders.filter(o => o.internal === 1), dirty: false});
                    this.setState({externalOrders: orders.filter(o => o.internal === 0), dirty: false});
                }
            });
        this.context.cachedGet(`/lookup/test_type?orderBy=testType`, 300)
            .then(d => this.setState({testTypes: d.data}));
        this.context.cachedGet(`/lookup/subspecialty?orderBy=subspecialty`, 300)
            .then(d => this.setState({testSubtypes: d.data}));
    }

    save = () => {
        this.context.apiRequest("POST", "/superbillMeta", this.state.internalOrders.concat(this.state.externalOrders))
            .then(this.loadData);
    }

    toggleOrder = (internal, orderIndex) => {
        let orders = internal ? [...this.state.internalOrders] : [...this.state.externalOrders];
        let order = orders[orderIndex];
        if (order) {
            if (order.expanded === true) {
                order.expanded = false;
            } else {
                order.expanded = true;
            }
        }
        if (internal) {
            this.setState({internalOrders: orders});
        } else {
            this.setState({externalOrders: orders});
        }
    }

    toggleOrderBool = (e, internal, orderIndex) => {
        let orders = internal ? [...this.state.internalOrders] : [...this.state.externalOrders];
        let order = orders[orderIndex];
        if (order) {
            let prop = e.target.name;
            let checked = e.target.checked;
            order[prop] = checked ? 1 : 0;
        }
        if (internal) {
            this.setState({internalOrders: orders, dirty: true});
        } else {
            this.setState({externalOrders: orders, dirty: true});
        }
    }

    toggleOptionBool = (e, internal, orderIndex, optionIndex) => {
        let orders = internal ? [...this.state.internalOrders] : [...this.state.externalOrders];
        let order = orders[orderIndex];
        if (order) {
            let option = order.options[optionIndex];
            if (option) {
                let prop = e.target.name;
                let checked = e.target.checked;
                option[prop] = checked ? 1 : 0;
            }
            if (internal) {
                this.setState({internalOrders: orders, dirty: true});
            } else {
                this.setState({externalOrders: orders, dirty: true});
            }
        }
    }

    orderStringChanged = (e, internal, orderIndex, blankToNull) => {
        let orders = internal ? [...this.state.internalOrders] : [...this.state.externalOrders];
        let order = orders[orderIndex];
        if (order) {
            let prop = e.target.name;
            let val = e.target.value;
            if (val === "" && blankToNull) val = null;
            order[prop] = val;
        }
        if (internal) {
            this.setState({internalOrders: orders, dirty: true});
        } else {
            this.setState({externalOrders: orders, dirty: true});
        }
    }

    optionStringChanged = (e, internal, orderIndex, optionIndex, blankToNull) => {
        let orders = internal ? [...this.state.internalOrders] : [...this.state.externalOrders];
        let order = orders[orderIndex];
        if (order) {
            let option = order.options[optionIndex];
            if (option) {
                let prop = e.target.name;
                let val = e.target.value;
                if (val === "" && blankToNull) val = null;
                option[prop] = val;
            }
            if (internal) {
                this.setState({internalOrders: orders, dirty: true});
            } else {
                this.setState({externalOrders: orders, dirty: true});
            }
        }
    }

    newOrder = (internal) => {
        let orders = internal ? [...this.state.internalOrders] : [...this.state.externalOrders];
        orders.unshift({
            id: 0,
            options: [],
            name: "",
            sortOrder: 0,
            internal,
            testCode: null,
            supportsDueDate: 0
        });
        if (internal) {
            this.setState({internalOrders: orders, dirty: true});
        } else {
            this.setState({externalOrders: orders, dirty: true});
        }
    }

    newOption = (internal, orderIndex) => {
        let orders = internal ? [...this.state.internalOrders] : [...this.state.externalOrders];
        let order = orders[orderIndex];
        order.options = [{
            optionId: 0,
            name: "",
            type: "BOOL",
            optionSortOrder: 0,
            testSubtypeCode: null,
            optionSupportsDueDate: 0,
            optionSupportsDx: 0
        }, ...order.options];
        order.expanded = true;
        if (internal) {
            this.setState({internalOrders: orders, dirty: true});
        } else {
            this.setState({externalOrders: orders, dirty: true});
        }
    }

    orderTable = (internal) => {
        let orders = internal ? this.state.internalOrders : this.state.externalOrders;

        return <Table borderless striped className={"ml-2 mt-2"}>
            <thead>
            <tr>
                <td>
                    <Row className={"font-weight-bold align-items-center"}>
                        <Col sm={1}></Col>
                        <Col sm={3}>Name</Col>
                        <Col sm={1} className={"text-center"}>Order</Col>
                        <Col sm={4} className={"text-center"}>Test Type</Col>
                        <Col sm={2} className={"text-center"}>Supports Due Date?</Col>
                        <Col sm={1} className={"text-center"}></Col>
                    </Row>
                </td>
            </tr>
            </thead>
            <tbody>
            {
                orders.map((o,i) => <tr key={i} className={"ml-2"} style={{verticalAlign: "middle"}}>
                    <td>
                    <Row className={"align-items-center"}>
                        <Col sm={1} className={"align-middle text-center"}>
                        {o.options && o.options.length > 0 &&
                                <Glyph name={o.expanded === true ? "dash-square" : "plus-square"} className={"clickable"} onClick={e => this.toggleOrder(internal, i)}/>
                        }
                        </Col>
                        <Col sm={3} className={"align-middle"}><FormControl size={"sm"} required name={"name"} value={o.name}
                                                                    onChange={e => this.orderStringChanged(e, internal, i, false)}/>
                        </Col>
                        <Col sm={1} className={"text-center align-middle"}>
                            <FormControl size={"sm"} required name={"sortOrder"} value={o.sortOrder}
                                         onChange={e => this.orderStringChanged(e, internal, i, false)}/>
                        </Col>
                        <Col sm={4} className={"text-center align-middle"}>
                            <OptionalSelect name={"testCode"} value={o.testCode}
                                            onChange={e => this.orderStringChanged(e, internal, i, true)}
                                            options={this.state.testTypes} valueKey={"testCode"} labelKey={"testType"}
                                            canSelectNone={true} noneLabel={"None"} noneValue={""}/>
                        </Col>
                        <Col sm={2} className={"text-center align-middle"}>
                            <FormCheck name={"supportsDueDate"} type={"checkbox"} checked={o.supportsDueDate == 1}
                                       onChange={e => this.toggleOrderBool(e, internal, i)}/>
                        </Col>
                        <Col sm={1} className={"text-center align-middle"}>
                            <Glyph name={"node-plus"} label={"New Option"} className={"clickable"} onClick={() => this.newOption(internal, i)}/>
                        </Col>
                    </Row>
                    {o.options && o.expanded && <>
                        <Row className={"font-weight-bold mt-2"}>
                            <Col sm={1} className={"text-center"}></Col>
                            <Col sm={3} className={"text-center"}>Option Name</Col>
                            <Col sm={2} className={"text-center"}>Type</Col>
                            <Col sm={1} className={"text-center"}>Order</Col>
                            <Col sm={2} className={"text-center"}>Test Subtype</Col>
                            <Col sm={1} className={"text-center"}>DX?</Col>
                            <Col sm={2} className={"text-center"}>Due Date?</Col>
                        </Row>

                    {o.options.map((oo,j) => <Row key={""+i+"_"+j} className={"align-items-center"}>
                        <Col sm={1} className={"align-middle"}></Col>
                        <Col sm={3}><FormControl size={"sm"} required name={"optionName"} value={oo.optionName}
                                          onChange={e => this.optionStringChanged(e, internal, i, j, false)}/></Col>
                        <Col sm={2} className={"text-center align-middle"}>
                            <OptionalSelect name={"type"} value={oo.type}
                                            onChange={e => this.optionStringChanged(e, internal, i, j,true)}
                                            options={this.OPTION_TYPES} valueKey={"value"} labelKey={"label"}
                                            canSelectNone={false}/>
                        </Col>
                        <Col sm={1} className={"text-center align-middle"}>
                            <FormControl size={"sm"} required name={"optionSortOrder"} value={oo.optionSortOrder}
                                         onChange={e => this.optionStringChanged(e, internal, i, j)}/>
                        </Col>
                        <Col sm={2} className={"text-center align-middle"}>
                            <OptionalSelect name={"testSubtypeCode"} value={oo.testSubtypeCode}
                                            onChange={e => this.optionStringChanged(e, internal, i, j, true)}
                                            options={this.state.testSubtypes} valueKey={"subspecialtyCode"} labelKey={"subspecialty"}
                                            canSelectNone={true} noneLabel={"None"} noneValue={""}/>
                        </Col>
                        <Col sm={1} className={"text-center align-middle"}>
                            <FormCheck name={"optionSupportsDx"} type={"checkbox"} checked={oo.optionSupportsDx == 1}
                                       onChange={e => this.toggleOptionBool(e, internal, i, j)}/>
                        </Col>
                        <Col sm={2} className={"text-center align-middle"}>
                            <FormCheck name={"optionSupportsDueDate"} type={"checkbox"} checked={oo.optionSupportsDueDate == 1}
                                       onChange={e => this.toggleOptionBool(e, internal, i, j)}/>
                        </Col>
                    </Row>)}
                    </>
                    }
                    </td></tr>)
            }
            </tbody>
        </Table>
    }

    render() {
        return <Container>
            <Row>
                <Col className={"text-right"}>
                    {this.state.dirty && <>
                        <Button variant={"outline-secondary"} className={"mr-2"} onClick={this.loadData}><Glyph name={"arrow-clockwise"}/> Reset</Button>
                        <Button variant={"secondary"} onClick={this.save}><Glyph name={"floppy"}/> Save All</Button>
                    </>}
                </Col>
            </Row>
            <Row>
                <Col>
                    <h5>Internal Orders</h5>
                </Col>
                <Col sm={"auto"} className={"text-right"}>
                    <Button size={"sm"} variant={"link"} onClick={() => this.newOrder(1)}>New Internal Order</Button>
                </Col>
            </Row>
            <Row>
                <Col>
                    {this.orderTable(1)}
                </Col>
            </Row>


            <Row className={"mt-3"}>
                <Col>
                    <h5>External Orders</h5>
                </Col>
                <Col sm={"auto"} className={"text-right"}>
                    <Button size={"sm"} variant={"link"} onClick={() => this.newOrder(0)}>New External Order</Button>
                </Col>
            </Row>
            <Row>
                <Col>
                    {this.orderTable(0)}
                </Col>
            </Row>

        </Container>
    }
}